// extracted by mini-css-extract-plugin
module.exports = {"StandingsTable":"StandingsTable_StandingsTable__1iYK9","sub":"StandingsTable_sub__2ejkK","left":"StandingsTable_left__1A_Vj","round":"StandingsTable_round__2K_SI"};